/**
 * @file: index.tsx
 * @copyright: (c) 2019-2021 sichuan zhichetech co., ltd.
 *
 * Book a reservation from a lead. The server copies the customer + vehicle from
 * the lead, so the staff only supply intake details (expected arrival, order
 * tags, mileage, advisor, customer type, remark); the confirmed lead items +
 * license plate are shown read-only as context. The surface borrows the
 * lead-detail design language so it reads as one app with the detail /
 * log-activity screens. Thin wrapper: fetch the lead, then render the form.
 */

import { DefaultLoader } from '@euler/app/components/loaders/DefaultLoader';
import { ReservationForm } from '@euler/app/flows/leads/pages/create-reservation/components/ReservationForm';
import { useLeadDetail } from '@euler/app/flows/leads/pages/detail/functions/useLeadDetail';
import { Center } from '@euler/components/Center';
import { EmptyView } from '@euler/components/EmptyView';
import { wrapNavigatorScreen } from '@euler/functions/wrapNavigatorScreen';

export const CreateLeadReservationScreen = wrapNavigatorScreen(
  ({ leadId }: { leadId: string }) => {
    const query = useLeadDetail(leadId);
    const detail = query.state;

    if (query.loading && detail == null) {
      return (
        <Center css={'flex: 1;'}>
          <DefaultLoader />
        </Center>
      );
    }
    if (detail == null) {
      return <EmptyView error={query.error} onRetry={query.invalidate} />;
    }
    return <ReservationForm leadId={leadId} detail={detail} />;
  },
  {
    title: '创建预约',
  },
);
